module.exports = __webpack_public_path__ + "static/city_step08-7b44e88cb546951b5b919d04157ca889.png";